import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * One QueryClient for the whole app, tuned for a venue on patchy Wi-Fi:
 * - staleTime 30s: going back to a list you saw a moment ago shows it at once instead of spinning.
 *   Writes still call invalidateQueries, so a change is never hidden behind the cache.
 * - gcTime 5 min: data for a screen you left stays in memory a little while so coming back is instant.
 * - No refetch on window focus: switching from the printer dialog or another tab back to the POS
 *   should not fire a burst of requests. Live boards (gate, POS stock, cashier desk) poll with their
 *   own refetchInterval, which this does not touch.
 * - One retry, and only for network or server trouble; a 4xx answer is final.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 1,
    },
  },
});
